/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const FolderMoveToIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Folder Move To',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 20 20"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M16.75,5h-5.96387c-.21777,0-.42383-.09375-.56641-.25879l-1.7041-1.96387c-.42676-.49414-1.0459-.77734-1.7002-.77734h-3.56543c-1.24023,0-2.25,1.00977-2.25,2.25v9.41699c0,.41406.33594.75.75.75s.75-.33594.75-.75v-7.16699h14.25c.41309,0,.75.33691.75.75v7.5c0,.41309-.33691.75-.75.75h-5.25c-.41406,0-.75.33594-.75.75s.33594.75.75.75h5.25c1.24023,0,2.25-1.00977,2.25-2.25v-7.5c0-1.24023-1.00977-2.25-2.25-2.25ZM2.5,4.25c0-.41309.33691-.75.75-.75h3.56543c.21777,0,.42383.09375.56641.25879l1.07703,1.24121H2.5v-.75Z"
      fill="currentColor"
      stroke-width="0"
    />
    <path
      d="M9.25,10.02148h-3.5c-.41406,0-.75.33594-.75.75s.33594.75.75.75h1.66797l-4.69824,4.69824c-.29297.29297-.29297.76758,0,1.06055.14648.14648.33789.21973.53027.21973s.38379-.07324.53027-.21973l4.71973-4.71973v1.71094c0,.41406.33594.75.75.75s.75-.33594.75-.75v-3.5c0-.41406-.33594-.75-.75-.75Z"
      fill="currentColor"
      stroke-width="0"
    />
  </svg>`;
};
